import React from "react";
import ReactInputMask from "react-input-mask";

export const TextMaskCep = React.forwardRef(function TextMaskCep(props, ref) {
  const { onChange, ...other } = props;

  return (
    <ReactInputMask
      mask="99999-999"
      maskChar={null}
      {...other}
      onChange={onChange}
    >
      {(inputProps) => <input {...inputProps} ref={ref} />}
    </ReactInputMask>
  );
});
